import { Type } from 'class-transformer';
import { WorkOrderVendorProposalFileInfoRawDto } from './work-order-vendor-proposal-file-info-raw-dto';

export class VendorProposalQuoteAcceptedEditorResultDto {
    @Type(() => WorkOrderVendorProposalFileInfoRawDto)
    vendorProposalQuotesAccespted: Array<WorkOrderVendorProposalFileInfoRawDto>;
}
